function normalizeRosterId(value) {
  if (value === null || value === undefined || value === '') return null;
  const parsed = Number(value);
  return Number.isInteger(parsed) ? parsed : null;
}

export function resolveLorRosterId(currentUser, rosters = [], storedRosterId = null) {
  const membership = currentUser?.memberships?.find(
    item => item.kind === 'lor' && item.roster_id !== null && item.roster_id !== undefined
  );
  const membershipRosterId = normalizeRosterId(membership?.roster_id);
  if (membershipRosterId !== null) return membershipRosterId;

  if (!currentUser?.guest && currentUser?.user_id) {
    const match = rosters.find(
      roster => String(roster.owner_id) === String(currentUser.user_id)
    );
    if (match) return normalizeRosterId(match.roster_id);
  }

  const stored = normalizeRosterId(storedRosterId);
  if (stored !== null && rosters.some(roster => normalizeRosterId(roster.roster_id) === stored)) {
    return stored;
  }

  return null;
}
